import React, { FC } from 'react';
import { Col, Row } from 'antd';
import { useSubscription } from '@apollo/client'

import { ACCOUNT_FORMS_COUNT, ACCOUNT_FORM_ENTRIES_COUNT, ACCOUNT_STATS_SUBSCRIPTION, ACCOUNT_MEMBERSHIPS_COUNT } from 'shared/gql';
import { Stat } from 'shared';
import AppState from 'shared/app_state';



type CountStatType = 'Forms' | 'Entries' | 'Memberships';

export const Stats: FC<{ accountId: string }> = ({ accountId }) => {
  const [accountRealtimeStats, setAccountRealtimeStats] = React.useState<{ [key: string]: number }>()

  const parseCountStat = (resource: CountStatType): ((data: { [key: string]: { count: number } }) => number) =>
    (data) => {
      const result = data[`_all${resource}Meta`];
      return result ? result.count : null;
    };

  useSubscription(ACCOUNT_STATS_SUBSCRIPTION, {
    variables: { accountId: AppState.getCurrentAccount().id },
    onSubscriptionData: (data) => {
      const { subscriptionData: { data: { accountStats: { payload: accountStats } } } } = data

      setAccountRealtimeStats(accountStats)
    }
  })

  return (
    <Row gutter={26} style={{
      marginTop: 36
    }}>
      <Col span={12}>
        <Stat
          // href="/services/form"
          parseQueryResult={parseCountStat('Entries')}
          query={ACCOUNT_FORM_ENTRIES_COUNT}
          title="Entries"
          subTitle="All-Time"
          variables={{ filter: { accountId } }}
          realtimeValue={accountRealtimeStats?.total_entries}
        />
      </Col>
      <Col span={12}>
        <Stat
          // href="/services/form"
          parseQueryResult={parseCountStat('Forms')}
          query={ACCOUNT_FORMS_COUNT}
          title="Forms"
          subTitle="Currently active"
          variables={{ filter: { accountId } }}
          realtimeValue={accountRealtimeStats?.total_forms}
        />
      </Col>
      {/* <Stat
          // href="/account/team"
          parseQueryResult={parseCountStat('Memberships')}
          query={ACCOUNT_MEMBERSHIPS_COUNT}
          title="Collaborators"
          variables={{ filter: { accountId, status: 'active' } }}
        />
        <Link to="/account/team">Invite team members</Link> */}
    </Row>
  );
};
